import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import LogoImage from '../../assets/LOGO-128.png';

/**
 * Fuss aller oeffentlichen Seiten. Pfad bleibt stabil (Werkstatt-Tests mocken ihn).
 *
 * Bewusst immer dunkel (TOKENS.md, Bewusste Ausnahmen) — deshalb feste
 * Grau-Werte statt Theme-Tokens; nur der Fokus kommt aus dem System.
 * Link-Texte sind ihr eigener Name (kein abweichendes aria-label, WCAG 2.5.3).
 * Anker auf der Landingpage laufen ueber den Hash; LandingPage scrollt dorthin.
 */
const PAGES = [
  { label: "So geht's", to: { pathname: '/', hash: '#so-gehts' } },
  { label: 'Für Schulen', to: '/start' },
  { label: 'Technik & Datenschutz', to: '/administration' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Werkstatt', to: '/werkstatt' },
  { label: 'Kontakt', to: { pathname: '/', hash: '#contact' } },
];

const LEGAL = [
  { label: 'Über mich', to: '/ueber-mich' },
  { label: 'Impressum', to: '/impressum' },
  { label: 'Datenschutz', to: '/datenschutz' },
  { label: 'Konto löschen', to: '/konto-loeschen' },
  { label: 'AGB', to: '/agb' },
  { label: 'AVV (Schulen)', to: '/avv' },
];

const linkClass = 'inline-block rounded px-1 py-1 -mx-1 text-gray-300 transition-colors hover:text-white focus-visible:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900';

const LinkList = ({ title, items }) => (
  <nav aria-label={title}>
    <h2 className="text-sm font-semibold text-white mb-4">{title}</h2>
    <ul className="space-y-1.5">
      {items.map((item) => (
        <li key={item.label}>
          <Link to={item.to} className={linkClass}>{item.label}</Link>
        </li>
      ))}
    </ul>
  </nav>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="relative z-10 bg-gray-900 text-white border-t border-white/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              {/* Der Footer ist immer dunkel — Logo fest auf helle Linien. */}
              <img src={LogoImage} alt="" width="32" height="32" loading="lazy" className="w-8 h-8 brightness-0 invert" />
              <span className="font-display uppercase tracking-[0.02em] text-lg">EachOtter</span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md leading-relaxed">
              Peer-Learning für Schulen. Schüler:innen finden an ihrer Schule Lernpartner:innen
              und lernen voneinander.
            </p>
            <div className="space-y-2.5 text-gray-300">
              <p className="flex items-center gap-3">
                <Mail className="w-4 h-4 shrink-0" aria-hidden="true" />
                <a href="mailto:info@eachotter.de" className={linkClass}>info@eachotter.de</a>
              </p>
              <p className="flex items-center gap-3">
                <MapPin className="w-4 h-4 shrink-0" aria-hidden="true" />
                <span>Tarpenbekstraße 48, 20251 Hamburg</span>
              </p>
            </div>
          </div>

          <LinkList title="Seiten" items={PAGES} />
          <LinkList title="Rechtliches" items={LEGAL} />
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-sm text-gray-400">
          <p>© {currentYear} EachOtter. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
